import store from '@/store'

export default function postAppMessage (handler: string, message: any) : void {
  if (!store.getters.isWebViewMode) return

  if (window.webkit) {
    if (window.webkit.messageHandlers[handler] !== undefined) {
      window.webkit.messageHandlers[handler].postMessage(message)
    }
  } else {
    if ((window as any)[handler] !== undefined) {
      if (typeof message === 'object') {
        (window as any)[handler].postMessage(JSON.stringify(message))
      } else {
        (window as any)[handler].postMessage(message)
      }
    }
  }
}

export const enum MessageHandlers {
  UPDATE_ROUTE = 'updateRoute',
  LOAD_USER_INFO = 'loadUserInfo',
  SAVE_USER_INFO = 'saveUserInfo',
  NAVIGATE_TO_PRODUCT = 'navigateToProduct',
  UPDATE_CART_BADGE = 'updateCartBadge',
  ON_TRANSACTION_SUCCESS = 'onTransactionSuccess',
  ADD_TO_CART = 'addToCart',
  INITIATED_CHECKOUT = 'initiatedCheckout',
  PURCHASE ='purchase',
  ON_BOOK_UPLOAD_SUCCESS = 'onBookUploadSuccess',
  ON_UPLOAD_SUCCESS = 'onUploadSuccess',
  UPDATE_HEADER = 'updateHeader',
  NAVIGATE_TO_MODIFY_PASSWORD = 'navigateToModifyPassword',
  NAVIGATE_TO_SETTING = 'navigateToSetting',
  DELETE_ACCOUNT = 'deleteAccount',
}
